import { render, staticRenderFns } from "./XSSPayloadFireReports.vue?vue&type=template&id=0f4c8c44&"
import script from "./XSSPayloadFireReports.vue?vue&type=script&lang=js&"
export * from "./XSSPayloadFireReports.vue?vue&type=script&lang=js&"
import style0 from "./XSSPayloadFireReports.vue?vue&type=style&index=0&id=0f4c8c44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports